export const webAppVersion = '2.1.38';
